export const products = [
  // ─── SHORT SLEEVES ────────────────────────────────────────────────────────────
  {
    id: "bella-3001cvc",
    name: "Unisex CVC Jersey Tee",
    brand: "Bella Canvas",
    sku: "3001CVC",
    category: "Short Sleeves",
    badge: "Best Seller",
    image: "https://www.dfw.ink/uploads/product/7584-fl6818f7ce18b8c.jpg",
    description: "The softest, most comfortable CVC tee on the market. 52% Airlume combed and ring-spun cotton, 48% polyester.",
    colors: ["White", "Black", "Navy", "Red", "Forest", "Heather Grey", "Athletic Heather"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    features: ["52/48 cotton/poly blend", "Airlume combed ring-spun cotton", "Retail fit", "Tear away label"],
  },
  {
    id: "gildan-64000",
    name: "Softstyle T-Shirt",
    brand: "Gildan",
    sku: "64000",
    category: "Short Sleeves",
    badge: "Best Seller",
    image: "https://www.dfw.ink/uploads/product/52386-f-fl61ccc4ddd9821.jpg",
    description: "Silky soft ring-spun cotton. The go-to choice for custom printing. 4.5 oz, 100% ring-spun cotton.",
    colors: ["White", "Black", "Navy", "Red", "Royal", "Dark Heather", "Maroon", "Military Green"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["4.5 oz ring-spun cotton", "Silky smooth feel", "Tear-away label", "Semi-fitted"],
  },
  {
    id: "nextlevel-3600",
    name: "Unisex Cotton Tee",
    brand: "Next Level",
    sku: "3600",
    category: "Short Sleeves",
    badge: "Best Seller",
    image: "https://www.dfw.ink/uploads/product/3214-fl681a899fab5f2.jpg",
    description: "Retail-quality tee with superior softness. 4.3 oz, 100% combed ring-spun cotton for a premium look.",
    colors: ["White", "Black", "Indigo", "Royal", "Forest Green", "Turquoise", "Red", "Hot Pink"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
    features: ["4.3 oz combed ring-spun cotton", "Crew neck", "Side-seamed", "Tear away label"],
  },
  {
    id: "gildan-5000",
    name: "Heavy Cotton T-Shirt",
    brand: "Gildan",
    sku: "5000",
    category: "Short Sleeves",
    badge: "Sale",
    image: "https://www.dfw.ink/uploads/product/16-fl680a9c4501cc4.jpg",
    description: "America's best-selling t-shirt. 5.3 oz, 100% heavy cotton. Durable, versatile, and the most economical blank.",
    colors: ["White", "Black", "Navy", "Red", "Royal", "Forest Green", "Safety Green", "Safety Orange", "Charcoal", "Dark Heather"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    features: ["5.3 oz heavy cotton", "Classic fit", "Seamless double-needle collar", "Taped neck & shoulders"],
  },
  {
    id: "comfort-colors-1717",
    name: "Adult Heavyweight Ring Spun Tee",
    brand: "Comfort Colors",
    sku: "1717",
    category: "Short Sleeves",
    badge: "Sale",
    image: "https://www.dfw.ink/uploads/product/1822-fl681bcbaecd9db.jpg",
    description: "Garment-dyed for a vintage, worn-in look. 6.1 oz, 100% ring-spun cotton with a buttery soft feel.",
    colors: ["Ivory", "Grey", "Blue Jean", "Pepper", "Watermelon", "Seafoam", "Violet", "Mustard"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["6.1 oz 100% ring-spun cotton", "Garment dyed", "Relaxed fit", "Vintage aesthetic"],
  },
  {
    id: "as-colour-5001",
    name: "Staple Tee",
    brand: "AS Colour",
    sku: "5001",
    category: "Short Sleeves",
    badge: "New",
    image: "https://www.dfw.ink/uploads/product/5001-staple-tee-main-24965680aa2737c221.jpg",
    description: "The premium blank for brand-forward businesses. 4.4 oz combed cotton. Clean lines, retail fit, ultimate quality.",
    colors: ["White", "Black", "Bone", "Stone", "Navy", "Dusk", "Asphalt"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    features: ["4.4 oz combed cotton", "Retail slim fit", "1x1 rib knit collar", "Premium label"],
  },
  {
    id: "columbia-128705",
    name: "PFG Tamiami II Short Sleeve Shirt",
    brand: "Columbia",
    sku: "128705",
    category: "Short Sleeves",
    badge: "New",
    image: "https://www.dfw.ink/uploads/product/6411-fl680aa7b6c0165.jpg",
    description: "Outdoor-ready performance shirt with UPF 40+ protection. Perfect for construction, outdoor events, and fishing.",
    colors: ["White", "Cool Grey", "Collegiate Navy", "Sail", "Vivid Blue"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["UPF 40+ sun protection", "Moisture-wicking", "Roll-up sleeve feature", "Two chest pockets"],
  },
  {
    id: "gildan-h000",
    name: "Hammer T-Shirt",
    brand: "Gildan",
    sku: "H000",
    category: "Short Sleeves",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/6233-fl680a8c737eb08.jpg",
    description: "Heavyweight 6 oz 100% cotton. Built tough for workwear, construction, and trade company uniforms.",
    colors: ["White", "Black", "Sport Grey", "Safety Green", "Safety Orange", "Indigo Blue"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["6 oz 100% cotton", "Seamless rib collar", "Workwear durability", "Double-needle sleeves & hem"],
  },
  {
    id: "lane-seven-lst002",
    name: "Vintage T-Shirt",
    brand: "Lane Seven",
    sku: "LST002",
    category: "Short Sleeves",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/120584-omf-fl680a919355034.jpg",
    description: "Tri-blend vintage tee with exceptional softness and drape. Perfect for fashion brands and premium merch.",
    colors: ["Vintage Black", "Vintage Navy", "Vintage White", "Vintage Brown", "Vintage Royal"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    features: ["Tri-blend fabric", "Vintage washed finish", "Fashion retail fit", "Tear-away label"],
  },
  {
    id: "bella-3001y",
    name: "Youth Jersey Tee",
    brand: "Bella Canvas",
    sku: "3001Y",
    category: "Short Sleeves",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/2209-fl680a92c8b3c6a.jpg",
    description: "The kids' version of the best-selling 3001. Same Airlume cotton, perfect for school spirit wear and youth teams.",
    colors: ["White", "Black", "Navy", "Red", "Athletic Heather", "True Royal"],
    sizes: ["XS", "S", "M", "L", "XL"],
    features: ["Airlume combed cotton", "Kids retail fit", "Tear-away label", "Side-seamed"],
  },
  {
    id: "bella-3005",
    name: "Jersey V-Neck Tee",
    brand: "Bella Canvas",
    sku: "3005",
    category: "Short Sleeves",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/24-fl680a93313e8ac.jpg",
    description: "Classic V-neck in premium Airlume cotton. Retail fit, great for corporate casual and healthcare uniforms.",
    colors: ["White", "Black", "Navy", "Grey", "Red", "Forest", "Vintage Black"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    features: ["Airlume combed cotton", "V-neck style", "Semi-fitted", "Tear-away label"],
  },
  {
    id: "bella-3200",
    name: "Three-Quarter Sleeve Baseball Tee",
    brand: "Bella Canvas",
    sku: "3200",
    category: "Short Sleeves",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/2764-fl680a9397355c6.jpg",
    description: "Classic raglan baseball tee. Perfect for sports teams, events, and that throwback athletic look.",
    colors: ["White/Black", "White/Red", "White/Navy", "White/Forest", "White/Royal"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    features: ["50/50 cotton/poly blend", "Raglan 3/4 sleeves", "Contrast sleeve colors", "Athletic fit"],
  },
  {
    id: "bella-6004",
    name: "Women's Slim Fit Tee",
    brand: "Bella Canvas",
    sku: "6004",
    category: "Short Sleeves",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/2020-fl680a9662d2c29.jpg",
    description: "Fitted women's tee in premium Airlume cotton. Popular for fitness studios, salons, and boutique brands.",
    colors: ["White", "Black", "Navy", "Red", "Forest", "Royal", "Athletic Heather"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    features: ["Airlume combed cotton", "Women's slim cut", "Soft feel", "Tear-away label"],
  },

  // ─── LONG SLEEVES ─────────────────────────────────────────────────────────────
  {
    id: "bella-3501",
    name: "Jersey Long Sleeve Tee",
    brand: "Bella Canvas",
    sku: "3501",
    category: "Long Sleeves",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/123-fl680a94bfde608.jpg",
    description: "Long sleeve version of the iconic 3001 tee. Premium Airlume cotton, retail fit.",
    colors: ["White", "Black", "Navy", "Red", "Athletic Heather", "Dark Grey"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    features: ["Airlume combed cotton", "Retail fit", "Long sleeve", "Tear-away label"],
  },
  {
    id: "gildan-5400",
    name: "Heavy Cotton Long Sleeve",
    brand: "Gildan",
    sku: "5400",
    category: "Long Sleeves",
    badge: null,
    image: "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=400&q=80",
    description: "6 oz heavy cotton long sleeve. The durable, economical choice for fall events and corporate uniforms.",
    colors: ["White", "Black", "Navy", "Maroon", "Dark Heather", "Safety Green"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["6 oz heavy cotton", "Taped neck and shoulders", "Double-needle hem", "Set-in sleeves"],
  },
  {
    id: "nextlevel-3601",
    name: "Men's Long Sleeve Tee",
    brand: "Next Level",
    sku: "3601",
    category: "Long Sleeves",
    badge: null,
    image: "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=400&q=80",
    description: "Premium retail-fit long sleeve tee. Combed ring-spun cotton for a luxuriously soft feel.",
    colors: ["White", "Black", "Indigo", "Heather Grey", "Royal"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    features: ["4.3 oz combed ring-spun cotton", "Retail fit", "Side-seamed", "Tear-away label"],
  },

  // ─── SWEATSHIRTS ──────────────────────────────────────────────────────────────
  {
    id: "itc-ind4000",
    name: "Heavyweight Hooded Sweatshirt",
    brand: "Independent Trading Co.",
    sku: "IND4000",
    category: "Sweatshirts",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/403-fl680a8cd0255e2.jpg",
    description: "8.5 oz heavyweight fleece hoodie. The premium choice for cold-weather custom printing.",
    colors: ["White", "Black", "Navy", "Cardinal Red", "Forest Green", "Gunmetal", "Heather Grey", "Maroon"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    features: ["8.5 oz 80/20 cotton/poly", "Heavyweight fleece", "Double-lined hood", "Two kangaroo pockets"],
  },
  {
    id: "lane-seven-ls1200",
    name: "Women's Cropped Fleece Hooded Sweatshirt",
    brand: "Lane Seven",
    sku: "LS1200",
    category: "Sweatshirts",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/13475-fl680a90d174881.jpg",
    description: "Trendy cropped hoodie for fashion brands, boutiques, and fitness studios. Streetwear essential.",
    colors: ["White", "Black", "Vintage Black", "Stone", "Sage"],
    sizes: ["XS", "S", "M", "L", "XL"],
    features: ["Cropped fleece style", "Women's streetwear fit", "Hood with drawcord", "Front kangaroo pocket"],
  },
  {
    id: "lane-seven-ls14001",
    name: "Premium Pullover Hooded Sweatshirt",
    brand: "Lane Seven",
    sku: "LS14001",
    category: "Sweatshirts",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/13530-fl680a911071d21.jpg",
    description: "Premium heavyweight pullover hoodie with buttery soft fleece lining. Built for print and retail quality.",
    colors: ["Black", "White", "Navy", "Heather Grey", "Vintage Black"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    features: ["Premium heavyweight fleece", "Double-lined hood", "Set-in sleeves", "Retail quality finish"],
  },
  {
    id: "lane-seven-lst004",
    name: "Vintage Raglan Hooded Sweatshirt",
    brand: "Lane Seven",
    sku: "LST004",
    category: "Sweatshirts",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/13542-fl6813a9d72dc48.jpg",
    description: "Vintage-washed raglan hoodie with premium fleece feel. Perfect for retro branding and lifestyle apparel.",
    colors: ["Vintage Black", "Vintage Navy", "Vintage Maroon", "Vintage Brown"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    features: ["Vintage washed finish", "Raglan sleeve construction", "Premium fleece", "Kangaroo pouch pocket"],
  },
  {
    id: "bella-3901",
    name: "Sponge Fleece Raglan Crewneck",
    brand: "Bella Canvas",
    sku: "3901",
    category: "Sweatshirts",
    badge: null,
    image: "https://www.dfw.ink/uploads/product/100478-omf-fl680a94f4529ae.jpg",
    description: "Sponge fleece crewneck with raglan sleeves. Retail cut with premium feel — ideal for merch stores.",
    colors: ["White", "Black", "Deep Heather", "True Royal", "Navy", "Military Green"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    features: ["Sponge fleece fabric", "Raglan sleeve detail", "Retail fit", "Spandex rib cuffs"],
  },
  {
    id: "gildan-18000",
    name: "Heavy Blend Crewneck Sweatshirt",
    brand: "Gildan",
    sku: "18000",
    category: "Sweatshirts",
    badge: "Best Seller",
    image: "https://images.unsplash.com/photo-1556821840-3a63f15732ce?w=400&q=80",
    description: "The #1 selling sweatshirt in North America. 8 oz 50/50 blend, excellent for printing.",
    colors: ["White", "Black", "Navy", "Sport Grey", "Red", "Royal", "Dark Heather", "Maroon"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["8 oz 50/50 cotton/poly", "Air jet yarn", "Seamless double-needle collar", "Set-in sleeves"],
  },

  // ─── TANK TOPS ────────────────────────────────────────────────────────────────
  {
    id: "bella-3480",
    name: "Unisex Jersey Tank",
    brand: "Bella Canvas",
    sku: "3480",
    category: "Tank Tops",
    badge: null,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&q=80",
    description: "Premium Airlume cotton tank. Perfect for fitness studios, summer events, and fashion brands.",
    colors: ["White", "Black", "Navy", "Red", "Forest", "Athletic Heather"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    features: ["Airlume combed cotton", "Sleeveless", "Scoop neck", "Side-seamed"],
  },
  {
    id: "nextlevel-3633",
    name: "Women's Jersey Tank",
    brand: "Next Level",
    sku: "3633",
    category: "Tank Tops",
    badge: null,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&q=80",
    description: "Women's fitted jersey tank. Great for yoga studios, boutiques, and fitness merchandise.",
    colors: ["White", "Black", "Hot Pink", "Royal", "Red", "Forest Green"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    features: ["Combed cotton", "Women's fit", "Rib-knit straps", "Tear-away label"],
  },
  {
    id: "gildan-2200",
    name: "Ultra Cotton Tank Top",
    brand: "Gildan",
    sku: "2200",
    category: "Tank Tops",
    badge: null,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&q=80",
    description: "6 oz heavy cotton tank top. Durable and economical for bulk event orders.",
    colors: ["White", "Black", "Navy", "Red", "Safety Green", "Safety Orange"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["6 oz 100% cotton", "Double-needle armhole", "Sewn-in label", "Classic fit"],
  },

  // ─── POLOS ────────────────────────────────────────────────────────────────────
  {
    id: "core365-88181",
    name: "Men's Origin Performance Piqué Polo",
    brand: "Core365",
    sku: "88181",
    category: "Polos",
    badge: "Best Seller",
    image: "https://www.dfw.ink/uploads/product/88181-fb-z680a9f1bae652.jpg",
    description: "100% performance polyester piqué polo. Moisture-wicking, snag-resistant. The corporate standard.",
    colors: ["White", "Black", "True Royal", "Campus Gold", "Red", "Carbon"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
    features: ["100% polyester piqué", "Moisture wicking", "Snag resistant", "3-button placket"],
  },
  {
    id: "adidas-a130",
    name: "Adidas Golf Polo",
    brand: "Adidas",
    sku: "A130",
    category: "Polos",
    badge: null,
    image: "https://images.unsplash.com/photo-1617137968427-85924c800a22?w=400&q=80",
    description: "Premium Adidas performance golf polo. UPF 50+ protection, moisture management. Perfect for corporate golf events.",
    colors: ["White", "Black", "Collegiate Navy", "Power Red"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    features: ["UPF 50+", "Adidas moisture management", "3-button polo", "Side vents"],
  },
  {
    id: "sport-tek-k500",
    name: "Micropiqué Sport-Wick Polo",
    brand: "Sport-Tek",
    sku: "K500",
    category: "Polos",
    badge: null,
    image: "https://images.unsplash.com/photo-1617137968427-85924c800a22?w=400&q=80",
    description: "Athletic polo with Sport-Wick moisture management. Great value for team uniforms and corporate apparel.",
    colors: ["White", "Black", "True Navy", "True Red", "Forest Green", "True Royal"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
    features: ["100% polyester micropiqué", "Sport-Wick moisture management", "Self-fabric collar", "Side vents"],
  },

  // ─── HATS ─────────────────────────────────────────────────────────────────────
  {
    id: "richardson-112",
    name: "Trucker Snapback Cap",
    brand: "Richardson",
    sku: "112",
    category: "Hats",
    badge: "Best Seller",
    image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=400&q=80",
    description: "America's most-decorated trucker cap. Foam front, mesh back, flat bill. The screen printing and embroidery standard.",
    colors: ["Black/Black", "White/Black", "Navy/White", "Red/Black", "Khaki/Brown", "Charcoal/Black"],
    sizes: ["One Size (Snapback)"],
    features: ["Foam front panel", "Mesh back", "Snapback closure", "Perfect for embroidery"],
  },
  {
    id: "yp-6089m",
    name: "Dad Hat",
    brand: "YP Classics",
    sku: "6089M",
    category: "Hats",
    badge: null,
    image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=400&q=80",
    description: "Low-profile washed pigment-dyed cotton dad hat. The relaxed, vintage style trusted by brands nationwide.",
    colors: ["Black", "White", "Navy", "Khaki", "Pink", "Maroon", "Forest"],
    sizes: ["One Size (Strapback)"],
    features: ["Washed cotton", "Unstructured low profile", "Brass buckle closure", "Curved bill"],
  },
  {
    id: "adams-en102",
    name: "Sustainable Snapback",
    brand: "Adams",
    sku: "EN102",
    category: "Hats",
    badge: "New",
    image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=400&q=80",
    description: "Eco-friendly snapback made with recycled materials. Structured front, flat bill, and sustainability credentials.",
    colors: ["Black", "Navy", "Grey", "Olive", "Camo"],
    sizes: ["One Size (Snapback)"],
    features: ["Recycled materials", "Structured front", "Flat bill", "Snapback closure"],
  },
  {
    id: "flexfit-6277",
    name: "Wooly Combed Cap",
    brand: "Richardson",
    sku: "6277",
    category: "Hats",
    badge: null,
    image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=400&q=80",
    description: "Structured mid-profile cap for a clean, professional look. Premium embroidery base — trusted by corporate clients.",
    colors: ["Black", "Navy", "White", "Khaki", "Red", "Dark Green"],
    sizes: ["S/M", "L/XL", "XL/2XL"],
    features: ["Wooly combed polyester", "Stretch-fit", "Mid-profile structured", "8 rows stitching"],
  },

  // ─── TIE DYE ──────────────────────────────────────────────────────────────────
  {
    id: "colortone-1000",
    name: "Adult Tie-Dye Tee",
    brand: "Colortone",
    sku: "1000",
    category: "Tie Dye",
    badge: null,
    image: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=400&q=80",
    description: "Pre-dyed tie-dye tee with vibrant, unique patterns. Each shirt is one-of-a-kind.",
    colors: ["Berry Sorbet", "Blueberry Smash", "Cotton Candy", "Pacific", "Sunflower", "Tie Dye"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["Pre-dyed unique patterns", "100% cotton", "Crew neck", "Machine washable"],
  },
  {
    id: "comfort-colors-1745",
    name: "Garment-Dyed Tie-Dye Tee",
    brand: "Comfort Colors",
    sku: "1745",
    category: "Tie Dye",
    badge: null,
    image: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=400&q=80",
    description: "Comfort Colors quality meets tie-dye aesthetics. Premium ring-spun cotton with signature garment-dye finish.",
    colors: ["Spiral", "Crumple", "Sections", "Bull Eye"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["Ring-spun cotton", "Garment-dyed process", "Vintage feel", "Unique per garment"],
  },

  // ─── PERFORMANCE ──────────────────────────────────────────────────────────────
  {
    id: "a4-n3013",
    name: "Cooling Performance Tee",
    brand: "A4",
    sku: "N3013",
    category: "Performance",
    badge: null,
    image: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?w=400&q=80",
    description: "100% polyester moisture-wicking performance tee. Ideal for athletic uniforms and outdoor events.",
    colors: ["White", "Black", "Navy", "Red", "Royal", "Forest", "Safety Yellow"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
    features: ["100% polyester", "Moisture wicking", "UV protection", "Sublimation-friendly"],
  },
  {
    id: "sport-tek-st350",
    name: "PosiCharge Competitor Tee",
    brand: "Sport-Tek",
    sku: "ST350",
    category: "Performance",
    badge: "Best Seller",
    image: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?w=400&q=80",
    description: "PosiCharge technology locks in color and prevents shrinkage. The top choice for sports teams.",
    colors: ["White", "Black", "True Navy", "True Red", "True Royal", "Forest Green", "Neon Yellow", "Neon Orange"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
    features: ["PosiCharge color lock", "100% polyester", "Raglan sleeves", "Tag-free label"],
  },
  {
    id: "augusta-790",
    name: "Wicking Short Sleeve T-Shirt",
    brand: "Augusta Sportswear",
    sku: "790",
    category: "Performance",
    badge: null,
    image: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?w=400&q=80",
    description: "100% polyester moisture management performance tee. Affordable athletic blank trusted by coaches.",
    colors: ["White", "Black", "Navy", "Red", "Gold", "Purple", "Maroon", "Royal"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    features: ["100% polyester wicking", "Self-fabric collar", "Satin label", "Athletic fit"],
  },

  // ─── SWEATPANTS ───────────────────────────────────────────────────────────────
  {
    id: "jerzees-974mp",
    name: "NuBlend Sweatpants",
    brand: "Jerzees",
    sku: "974MP",
    category: "Sweatpants",
    badge: null,
    image: "https://images.unsplash.com/photo-1596783074918-c84cb06531ca?w=400&q=80",
    description: "Classic 8 oz NuBlend sweatpants. Economical option for athletic programs and school spirit sets.",
    colors: ["Black", "Charcoal Grey", "Navy", "Red", "White", "Maroon"],
    sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    features: ["8 oz 50/50 NuBlend", "Elastic waistband", "Pockets with set-in waistband", "Single pockets"],
  },
  {
    id: "itc-ind20pnt",
    name: "Midweight Fleece Pants",
    brand: "Independent Trading Co.",
    sku: "IND20PNT",
    category: "Sweatpants",
    badge: null,
    image: "https://images.unsplash.com/photo-1596783074918-c84cb06531ca?w=400&q=80",
    description: "7.2 oz midweight fleece sweatpants. Perfect for matching hoodie + pants sets and athletic programs.",
    colors: ["Black", "Gunmetal Heather", "Slate Blue", "Dusty Pine", "Bone"],
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
    features: ["7.2 oz fleece", "Tapered fit", "Deep front pockets", "Elastic cuffs"],
  },
];

export const categories = [
  "All",
  "Short Sleeves",
  "Long Sleeves",
  "Sweatshirts",
  "Tank Tops",
  "Polos",
  "Hats",
  "Tie Dye",
  "Performance",
  "Sweatpants",
];

export const brands = [
  "All Brands",
  "Bella Canvas",
  "Gildan",
  "Next Level",
  "Comfort Colors",
  "Independent Trading Co.",
  "Lane Seven",
  "AS Colour",
  "Columbia",
  "Core365",
  "Sport-Tek",
  "A4",
  "Augusta Sportswear",
  "Adidas",
  "Richardson",
  "YP Classics",
  "Adams",
  "Jerzees",
  "Colortone",
];
